module.exports = __webpack_public_path__ + "img/021-sway.788becde.svg";